Product = new Object();
Product.init = function() {
  Product.accordion();
};
Product.accordion = function() {
  $('.Product_main_accordion_cell .line').click(function() {
    let accordion = $(this).closest('.Product_main_accordion_cell');
    let active = $('.Product_main__accordion_outer .Product_main_accordion_cell.active');
    if (!accordion.hasClass('active')) {
      accordion.toggleClass('active');
      accordion.find('.info').slideToggle();
      active.removeClass('active');
    $('.info', active).slideToggle();
    } else {
      accordion.toggleClass('active').find('.info').slideToggle();
    }
  });

  let reviewsSummary = $('.product-page-view .product-information .product-head-top .rate .okeReviews-reviewsSummary');
  if (reviewsSummary.length) {
    let reviewsAccordion = $('.product-page-view .product-information .Product_main_accordion_cell.reviews-accordion');
    let reviewsCount = $(".product-page-view .product-information .product-head-top .rate .okeReviews-reviewsSummary-ratingCount span[aria-hidden='true']")
      .text().replace(" Reviews", "").replace(" reviews", "").replace(" Review", "").replace(" review", "");

    $('.line-details', reviewsAccordion).text(" (" + reviewsCount + ")");
  } 

  $('.product-page-view .product-information .product-head-top .rate .okeReviews-reviewsSummary').click(function() {
    let reviews = $('.product-page-view .product-information .Product_main_accordion_cell.reviews-accordion');
    let activeAccordion = $('.Product_main__accordion_outer .Product_main_accordion_cell.active');

    if (!reviews.hasClass('active')) {
      reviews.toggleClass('active');
      reviews.find('.info').slideToggle(); 

      activeAccordion.removeClass('active');
      $('.info', activeAccordion).slideToggle();
    }

    
  });
};

Product.calculateDeliveryDate = function(x, y) {
  // Get the current date
  var currentDate = new Date();

  // Define days and months arrays
  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function addBusinessDays(startDate, numDays) {
    var newDate = new Date(startDate);
    var businessDays = 0;

    while (businessDays < numDays) {
      newDate.setDate(newDate.getDate() + 1);

      // Check if the current day is a business day (Monday to Friday)
      if (newDate.getDay() !== 0 && newDate.getDay() !== 6) {
        businessDays++;
      }
    }

    return newDate;
  }

  // Calculate the first delivery date (skipping weekends)
  var firstDeliveryDate = addBusinessDays(currentDate, x);

  // Get day, date, and month for the first delivery date
  var firstDayName = days[firstDeliveryDate.getDay()];
  var firstDay = firstDeliveryDate.getDate();
  var firstMonth = months[firstDeliveryDate.getMonth()];

  // Format the first delivery date string
  var firstFormattedDate = firstDayName + ', ' + firstDay + ' ' + firstMonth;

  // Display the formatted first delivery date
  $('.Minimum_delivery_date_usa').text(firstFormattedDate);

  // Calculate the second delivery date (skipping weekends)
  var secondDeliveryDate = addBusinessDays(currentDate, y);

  // Get day, date, and month for the second delivery date
  var secondDayName = days[secondDeliveryDate.getDay()];
  var secondDay = secondDeliveryDate.getDate();
  var secondMonth = months[secondDeliveryDate.getMonth()];

  // Format the second delivery date string
  var secondFormattedDate = secondDayName + ', ' + secondDay + ' ' + secondMonth;

  // Display the formatted second delivery date
  $('.Maximum_delivery_date_usa').text(secondFormattedDate);
}

Product.calculateDeliveryDateInt = function(x, y) {
  // Get the current date
  var currentDate = new Date();

  // Define days and months arrays
  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function addBusinessDays(startDate, numDays) {
    var newDate = new Date(startDate);
    var businessDays = 0;

    while (businessDays < numDays) {
      newDate.setDate(newDate.getDate() + 1);

      // Check if the current day is a business day (Monday to Friday)
      if (newDate.getDay() !== 0 && newDate.getDay() !== 6) {
        businessDays++;
      }
    }

    return newDate;
  }

  // Calculate the first delivery date (skipping weekends)
  var firstDeliveryDate = addBusinessDays(currentDate, x);

  // Get day, date, and month for the first delivery date
  var firstDayName = days[firstDeliveryDate.getDay()];
  var firstDay = firstDeliveryDate.getDate();
  var firstMonth = months[firstDeliveryDate.getMonth()];

  // Format the first delivery date string
  var firstFormattedDate = firstDayName + ', ' + firstDay + ' ' + firstMonth;

  // Display the formatted first delivery date
  $('.Minimum_delivery_date_int').text(firstFormattedDate);

  // Calculate the second delivery date (skipping weekends)
  var secondDeliveryDate = addBusinessDays(currentDate, y);

  // Get day, date, and month for the second delivery date
  var secondDayName = days[secondDeliveryDate.getDay()];
  var secondDay = secondDeliveryDate.getDate();
  var secondMonth = months[secondDeliveryDate.getMonth()];

  // Format the second delivery date string
  var secondFormattedDate = secondDayName + ', ' + secondDay + ' ' + secondMonth;

  // Display the formatted second delivery date
  $('.Maximum_delivery_date_int').text(secondFormattedDate);
}

Product.initDeliveryTime = function() {
  var usa_delivery_minimum = $('.Delivery_date_terms__js').attr('data-usa-minimum');
  var usa_delivery_maximum = $('.Delivery_date_terms__js').attr('data-usa-maximum');
  var int_delivery_minimum = $('.Delivery_date_terms__js').attr('data-international-minimum');
  var int_delivery_maximum = $('.Delivery_date_terms__js').attr('data-international-maximum');
  Product.calculateDeliveryDate(usa_delivery_minimum , usa_delivery_maximum );
  Product.calculateDeliveryDateInt(int_delivery_minimum, int_delivery_maximum);
 $('.product-page-view .product-delivery').fadeIn('fast');

};

$(document).ready(function() {
  Product.init();
  Product.initDeliveryTime();

 // Cookies check
 /*if (String(window.location.href).indexOf('#50_sale_applied') != -1){
    document.cookie = "sale50Applied=enabled; expires=Thu, 1 Jan 2024 00:00:00 UTC; path=/";
}*/

 
  // Preparing environment for correct structured data, google feed variables
  function SettingUpPrice(){
      var currentUrl = String(window.location.href);
      if(currentUrl.indexOf('variant=') != -1){
        // Get the URL of the current page
        var currentURL = window.location.href;
        // Regular expression to match the "variant" parameter value
        var regex = /variant=([^&]+)/;
        
        // Extract the "variant" parameter value using the regular expression
        var match = currentURL.match(regex);
    
        // Check if the "variant" parameter value is found in the URL
        if (match && match.length > 1) {
          var variantValue = match[1]; 
          console.log('Variant value:', variantValue);
          // Now you can use the "variantValue" variable as needed
          // For example, you can use it to update elements on your page dynamically.
          $('.Product_section_price').hide();
          $('.Product_section_price').each(function(){
            if($(this).attr('data-id') == variantValue){
              $(this).show();
            }
          });
        } else {
          console.log('Variant parameter not found in the URL.');
        }
      }
  }

  //SettingUpPrice();

    /*function isSale50Enabled() {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i].trim();
          if (cookie.indexOf('sale50Applied=enabled') === 0) {
            // Temporary disabling this offer
            return false;
          }
        }
        return false;
      }*/

      /*if (isSale50Enabled()) {
        console.log("Sale 50 is enabled.");
        $('.Product_price_original__js').hide();
        $('.Product_price_sale__js').show();
        $('.OfferMessage').hide();
        $('.Product_pricing_note').hide();
      } else {
        console.log("Sale 50 is not enabled.");
        $('.Product_price_original__js').show();
        $('.Product_price_sale__js').hide();
      }*/



    /*$('.select-container  select').change(function(){
        var currentVariant = $('.Product_form_variant_selector__js').val();
        if (typeof(currentVariant) == 'undefined'){
            currentVariant = $('.OnetimeVariantSelector__js').val();
        } 
  
        // var dataInventory = 0;
        var dataInventory;
        console.log(dataInventory);

        // Price selector
        $('.Product_section_price').hide();
        $('.Product_section_price').each(function(){
            if ($(this).attr('data-id') == currentVariant){
                $(this).show();
                dataInventory = $(this).attr('data-inv');
            }
        });

        if (dataInventory == 0){
          $('.purchase-details').hide();
        }
        else{
          $('.purchase-details').show();
        }
        console.log(dataInventory, 'STOCK');
    });*/
    $('.product__images').addClass('loaded');


    $('.pdt_close').click(function(){
      $('.pdt_outer').hide();
    });

    $('.material-guide-action').click(function(){
      $('.pdt_outer').css('display', 'flex');
    });


  /*function makeTimer1() {
    var today = new Date();
    // Adjust for Canada time zone (UTC-5)
    today.setUTCHours(today.getUTCHours() - 5);

    var tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    var tomorrow_splitted = tomorrow.toString().split(' ');
    var tomorrow_day = tomorrow_splitted[2];
    var tomorrow_month = tomorrow_splitted[1];
    var tomorrow_year = tomorrow_splitted[3];

    var endTime = new Date(tomorrow_year, getMonthIndex(tomorrow_month), tomorrow_day, 0, 0, 0);	
    endTime = endTime.getTime() / 1000;

    var now = today.getTime() / 1000;

    var timeLeft = endTime - now;

    var days = Math.floor(timeLeft / 86400); 
    var hours = Math.floor(timeLeft / 3600);
    var hours_to_calc = Math.floor((timeLeft - (days * 86400)) / 3600);
    var minutes = Math.floor((timeLeft - (days * 86400) - (hours_to_calc * 3600 )) / 60);
    var seconds = Math.floor((timeLeft - (days * 86400) - (hours_to_calc * 3600) - (minutes * 60)));

    if (hours_to_calc < 10) { hours_to_calc = "0" + hours_to_calc; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }

    // Update HTML elements
    document.querySelector(".Product_pricing_note_timer .hours").innerHTML = hours_to_calc;
    document.querySelector(".Product_pricing_note_timer .minutes").innerHTML = minutes;
    document.querySelector(".Product_pricing_note_timer .seconds").innerHTML = seconds;
  }

  function getMonthIndex(month) {
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    return months.indexOf(month);
  }

  setInterval(function() { makeTimer1(); }, 1000);*/

  $(document).on("click",".material__swatch_type .swatch-element",function() {
    var currentVal = $(this).attr('data-value-handle');
    if (String(currentVal).indexOf('moissanite') != -1){
      $('.dt_container').show();
      $('.product-delivery').hide();
    }
    else{
      $('.dt_container').hide();
      $('.product-delivery').show();
    }
  });

  $(document).on("click",".swatch-element",function() {
    setTimeout(function(){
      $('.button--add-to-cart').removeClass('disabled');
      $('.button--add-to-cart').attr('disabled', false)
    },100);
  });


  $('.mois_up_btn_evi').click(function(){
    $('.mois_video').slideToggle();
    $('.mois_up_outer').toggleClass('video_visible');
  });
});